import { useClients, useProjects } from "@/lib/hooks";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

/** Codifica o "balde" de uma linha (cliente / projeto / interno) num único valor. */
export function bucketValue(line) {
  if (line.projectId) return `p:${line.projectId}`;
  if (line.clientId) return `c:${line.clientId}`;
  return "internal";
}

export function applyBucket(value) {
  if (value === "internal") return { clientId: "", projectId: "", internal: true };
  if (value.startsWith("c:")) return { clientId: value.slice(2), projectId: "", internal: false };
  if (value.startsWith("p:")) return { projectId: value.slice(2), clientId: "", internal: false };
  return { clientId: "", projectId: "", internal: true };
}

export function DayBucketSelect({ value, onChange, className }) {
  const { data: clients = [] } = useClients();
  const { data: projects = [] } = useProjects();

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={className} data-testid="day-bucket-select">
        <SelectValue placeholder="Cliente / projeto" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="internal">Interno (sem cliente)</SelectItem>
        {clients.length > 0 && (
          <SelectGroup>
            <SelectLabel>Clientes</SelectLabel>
            {clients.map((c) => (
              <SelectItem key={c.id} value={`c:${c.id}`}>{c.name}</SelectItem>
            ))}
          </SelectGroup>
        )}
        {projects.length > 0 && (
          <SelectGroup>
            <SelectLabel>Projetos</SelectLabel>
            {projects.map((p) => (
              <SelectItem key={p.id} value={`p:${p.id}`}>{p.name}</SelectItem>
            ))}
          </SelectGroup>
        )}
      </SelectContent>
    </Select>
  );
}
